const classSelect = {
  path: 'classSelect',
  component: resolve => require(['../../../pages/user/classselect/index'], resolve)
}

export default classSelect



// WEBPACK FOOTER //
// ./src/router/user/classselect/index.js